import CheckMark from '@/components/icons/checkMark'
import NotFound from '@/components/icons/notFound'

const EquipmentCardItem = ({ text, equipped }: { text: string; equipped: boolean }) => {
  return (
    <ul className="flex items-center gap-2">
      {equipped ? <CheckMark /> : <NotFound />}
      {text}
    </ul>
  )
}

export default EquipmentCardItem
